import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonTH from './locales/th/common.json';
import menuTH from './locales/th/menu.json';
import salesVisitTH from './locales/th/salesVisit.json';
import commonEN from './locales/en/common.json';
import menuEN from './locales/en/menu.json';
import salesVisitEN from './locales/en/salesVisit.json';
import taskTH from './locales/th/task.json';
import taskEN from './locales/en/task.json';
import ticketTH from './locales/th/ticket.json';
import ticketEN from './locales/en/ticket.json';
import calendarTH from './locales/th/calendar.json';
import calendarEN from './locales/en/calendar.json';
import customerTH from './locales/th/customer.json';
import customerEN from './locales/en/customer.json';
import performanceTH from './locales/th/performance.json';
import performanceEN from './locales/en/performance.json';
import dashboardTH from './locales/th/dashboard.json';
import dashboardEN from './locales/en/dashboard.json';
import opportunityTH from './locales/th/opportunity.json';
import opportunityEN from './locales/en/opportunity.json';
import aiTH from './locales/th/ai.json';
import aiEN from './locales/en/ai.json';
import assetTH from './locales/th/asset.json';
import assetEN from './locales/en/asset.json';

import profileTH from './locales/th/profile.json';
import profileEN from './locales/en/profile.json';
import notificationsTH from './locales/th/notifications.json';
import notificationsEN from './locales/en/notifications.json';
import memberTH from './locales/th/member.json';
import memberEN from './locales/en/member.json';
import omnichannelTH from './locales/th/omnichannel.json';
import omnichannelEN from './locales/en/omnichannel.json';

const resources = {
    th: {
        common: commonTH,
        menu: menuTH,
        salesVisit: salesVisitTH,
        task: taskTH,
        ticket: ticketTH,
        calendar: calendarTH,
        customer: customerTH,
        performance: performanceTH,
        dashboard: dashboardTH,
        opportunity: opportunityTH,
        ai: aiTH,
        asset: assetTH,
        profile: profileTH,
        notifications: notificationsTH,
        member: memberTH,
        omnichannel: omnichannelTH,
    },
    en: {
        common: commonEN,
        menu: menuEN,
        salesVisit: salesVisitEN,
        task: taskEN,
        ticket: ticketEN,
        calendar: calendarEN,
        customer: customerEN,
        performance: performanceEN,
        dashboard: dashboardEN,
        opportunity: opportunityEN,
        ai: aiEN,
        asset: assetEN,
        profile: profileEN,
        notifications: notificationsEN,
        member: memberEN,
        omnichannel: omnichannelEN,
    }
};

i18n
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
        resources,
        fallbackLng: 'en',
        debug: false,
        showSupportNotice: false, // ปิดการแสดงข้อความโฆษณา Locize ใน Console
        ns: ['common', 'menu', 'salesVisit', 'task', 'ticket', 'calendar', 'customer', 'performance', 'dashboard', 'opportunity', 'ai', 'asset', 'profile', 'notifications', 'member', 'omnichannel'], // namespaces
        defaultNS: 'common',
        defaultNS: 'common',

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        detection: {
            order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage'],
        }
    });

export default i18n;
